import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=325f3cab&"
import script from "./SubscriptionItem.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports